import * as React from "react";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {actions as authActions} from "../../reducers/auth";
import {useHistory, useLocation} from "react-router";
import {getUserMetadata} from "../../actions/boCoreActions";
import AuthUtils from "../../AuthUtils";
import Utils from "../../Utils";
import {actions as savedSearchActions} from "../../actions/savedSearchActions";
import {PublicRoutes, Routes, StaticRoutes} from "../../config/routes";

export default function Wrapper(props: any) {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector((store: any) => store.auth.user);
    const locale = useSelector((store: any) => store.auth.locale);
    const [showChildren, setShowChildrens] = useState<boolean>(false);
    const selectedSavedSearch = useSelector((store: any) => store.savedSearchReducer.selectedSearch);
    const userRoutes = useSelector((store: any) => store.auth.uiRoutes);

    useEffect(() => {
        if (location.pathname !== '/bocore/managedata' && location.pathname !== '/bocore/globalsearch' &&
            location.pathname !== '/bocore/audit-log' && !location.pathname.includes('/bocore/instance/')) {
            localStorage.removeItem('cameFromInstance');
        }
        if (location.pathname !== '/bocore/globalsearch' && !location.pathname.includes('/bocore/instance/')) {
            localStorage.removeItem('cameFromGlobalSearch');
        }
        if (location.pathname !== '/bocore/audit-log' && !location.pathname.includes('/bocore/instance/')) {
            localStorage.removeItem('cameFromAuditLog');
        }
        if (location.pathname !== '/bocore/managedata' && location.pathname !== '/bocore/globalsearch' &&
            location.pathname !== '/bocore/audit-log' && !location.pathname.includes('/bocore/instance/')) {
            if (selectedSavedSearch) {
                dispatch({type: savedSearchActions.SET_SELECTED_SEARCH, payload: null});
            }
        }
    }, [location]);

    useEffect(() => {
        if (AuthUtils.isAccessTokenPresent()) {
                AuthUtils.mySelfRequest({locale: locale});
        } else {
            history.push(`${process.env.ENV_PREFIX}${PublicRoutes.LOGIN}`);
        }
    }, [AuthUtils.mySelfRequest]);

    useEffect(() => {
        if (user) {
            getUserMetadata()
                .then(responses => {
                    dispatch({type: authActions.SET_TENANT, payload: responses[0].data});
                    setShowChildrens(true);
                    if (Utils.isPathPublic(location.pathname)) {
                        if (AuthUtils.user.mta || AuthUtils.user.systemAdministrator) {
                             history.push(`${process.env.ENV_PREFIX}${Routes.BASE_PATH}`);
                        } else if (userRoutes && userRoutes.length > 0) {
                            if (userRoutes && userRoutes.length === 1 && userRoutes[0] === Routes.BASE_PATH) {
                                history.push(`${process.env.ENV_PREFIX}${StaticRoutes.WELCOME}`);
                                return;
                            }
                            const homePage = userRoutes.find(route => route === Routes.BASE_PATH)
                            if (homePage) {
                                history.push(`${process.env.ENV_PREFIX}${Routes.BASE_PATH}`);
                            } else {
                                history.push(`${process.env.ENV_PREFIX}${userRoutes[0]}`);
                            }
                        } else if (userRoutes && userRoutes.length === 0) {
                            history.push(`${process.env.ENV_PREFIX}${StaticRoutes.WELCOME}`);
                        } else {
                            history.push(`${StaticRoutes.NOT_FOUND}`);
                        }
                     }
                })
                .catch(() => {
                    if (history.location.pathname !== `${process.env.ENV_PREFIX}${PublicRoutes.LOGIN}`) {
                        history.push(`${process.env.ENV_PREFIX}${PublicRoutes.LOGIN}`);
                    }
                    setShowChildrens(false);
                });
        } else {
            setShowChildrens(false);
        }
    }, [user]);

    if (showChildren) {
        return props.children
    }
    return null;
}



// WEBPACK FOOTER //
// ./app/components/layouts/Wrapper.tsx